import { render } from "./ObserverInfoToast.vue?vue&type=template&id=53b48a6b"
import script from "./ObserverInfoToast.vue?vue&type=script&lang=js"
export * from "./ObserverInfoToast.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__